import { render } from "./AddMagasinPage.vue?vue&type=template&id=a05733ee&ts=true"
import script from "./AddMagasinPage.vue?vue&type=script&lang=ts"
export * from "./AddMagasinPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__